export default "__VITE_ASSET__CqF61RS9__"